import React from 'react';
import cl from 'classnames';
import { Text } from '@topconagriculture/react-components';
import { useStyles } from './styles';
import { useTranslation } from 'react-i18next';
import { InventoryViewMode } from '../../inventory.types';
const Toggler = (props) => {
    const { viewMode, setViewMode, criticalCount, earlyCount } = props;
    const { t } = useTranslation();
    const classes = useStyles();
    const handleClick = (activeTab) => {
        setViewMode(activeTab);
    };
    return (React.createElement("div", { className: classes.tabs },
        React.createElement("button", { className: cl(classes.button, classes.leftButton, viewMode === InventoryViewMode.CRITICAL && classes.active), onClick: () => handleClick(InventoryViewMode.CRITICAL) },
            React.createElement(Text, null, `${t('widget:critical_warnings')} (${criticalCount})`)),
        React.createElement("button", { className: cl(classes.button, classes.rightButton, viewMode === InventoryViewMode.EARLY && classes.active), onClick: () => handleClick(InventoryViewMode.EARLY) },
            React.createElement(Text, null,
                React.createElement(Text, null, `${t('widget:early_warnings')} (${earlyCount})`)))));
};
export default Toggler;
//# sourceMappingURL=Toggler.js.map